/**
 * Facture PEPPOL — règles de app/(profile)/peppol-invoice.tsx et
 * src/lib/vat.ts du mobile.
 *
 * Un numéro de TVA belge : BE + 10 chiffres, le premier 0 ou 1. Les deux
 * derniers sont une clé mod 97 des huit premiers (97 - base % 97) : la forme
 * seule ne suffit pas, Odoo/PEPPOL refuse une clé fausse.
 */

import { cleanServerString } from "./orders";

/** Sans séparateurs, en majuscules, préfixe BE ajouté s'il manque. */
export function normalizeBelgianVat(raw) {
  const compact = String(raw || "").replace(/[\s.\-_/]/g, "").toUpperCase();
  if (!compact) return "";
  return /^BE/.test(compact) ? compact : `BE${compact}`;
}

export function isValidBelgianVat(raw) {
  const match = /^BE([01]\d{9})$/.exec(normalizeBelgianVat(raw));
  if (!match) return false;
  const digits = match[1];
  return Number(digits.slice(8, 10)) === 97 - (Number(digits.slice(0, 8)) % 97);
}

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/** Clés d'erreur (peppolInvoice.*) par champ, ou null si le champ est bon. */
export function invoiceErrors({ company, vat, email }) {
  const name = String(company || "").trim();
  const mail = String(email || "").trim();
  return {
    company: !name ? "companyRequired" : name.length < 2 ? "companyTooShort" : null,
    vat: !String(vat || "").trim() ? "vatRequired" : !isValidBelgianVat(vat) ? "vatInvalid" : null,
    email: !mail ? "emailRequired" : !EMAIL.test(mail) ? "emailInvalid" : null,
  };
}

export const hasErrors = (errors) => Object.values(errors).some(Boolean);

/**
 * Pré-remplissage : le profil d'abord, puis ce que renvoie la facture
 * publique quand c'est renseigné. Le backend écrit parfois « null » en
 * toutes lettres : ces valeurs comptent pour vides.
 */
export function prefill(profile = {}, invoice = {}) {
  const user = invoice?.user || {};
  const pick = (...values) => values.map(cleanServerString).find(Boolean) || "";
  return {
    company: pick(invoice?.company_name, user.company_name, profile?.company_name),
    vat: pick(invoice?.vat, user.vat, profile?.vat),
    email: pick(invoice?.email, user.email, profile?.email),
    address: pick(invoice?.invoicing_address, user.invoicing_address, profile?.invoicing_address),
  };
}

/** État de la page selon la réponse GET /public_invoices/:token. */
export function invoiceState(invoice) {
  if (invoice?.odoo_invoice_id !== null && invoice?.odoo_invoice_id !== undefined) return "generated";
  if (String(invoice?.payment_status || "").toLowerCase() === "unpaid") return "unpaid";
  return "form";
}
